const routes = {
  LOGIN: "/login",
  HOME: "/",
  LAYOUT: "/*",
  ERROR: "/error",
  SUBPAGE: "/subpage",
  SOFT_TAG_MANAGER: "/soft-tags",
};
export default routes;
